<div class="container-fluid mt-header">
    <div class="row">
        <div id="carouselBannerQuienesSomos" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-indicators">
              <button type="button" data-bs-target="#carouselBannerQuienesSomos" [attr.data-bs-slide-to]="j" [ngClass]="{'active': j == 0}" *ngFor="let c of carusel;let j = index" aria-current="true" aria-label="Slide {{j+1}}"></button>
            </div>
            <div class="carousel-inner">
                <div class="carousel-item"
                 [ngClass]="{'active':i==0}" 
                 data-bs-interval="10000" 
                 *ngFor="let c of carusel;let i = index"
                 (swipeleft)="sliderCarusel('left','carouselBannerQuienesSomos')" 
                 (swiperight)="sliderCarusel('right','carouselBannerQuienesSomos')" >
                    <div class="div-carousel">
                        <img [src]="banderaMobile ? c.imgMobile : c.img" class="d-block " [alt]="c.titulo">
                        <div class="d-block d-md-none card">
                            <div class="card-body text-center" [ngClass]="{'card-flex':i==3}">
                                <p *ngIf="i<3" class="card-text" [innerHtml]="c.descripcion"></p>
                                <ul class="ul-carusel" *ngIf="i==3">
                                    <li class="li-carusel" *ngFor="let v of c.valores">{{v}}</li>
                                </ul>
                            </div>
                            <div class="card-footer p-0 text-center">{{c.titulo}}</div>
                        </div>
                        <mat-card class="d-none d-md-block">
                            <mat-card-header>
                                <mat-card-title>{{c.titulo}}</mat-card-title>
                            </mat-card-header>
                            <ng-container *ngIf="i<3">
                                <mat-card-content class="card-content-banner">
                                    <p [innerHtml]="c.descripcion"></p>
                                </mat-card-content>
                            </ng-container>
                            <ng-container *ngIf="i==3">
                                <mat-card-content class="mat-content-valores">
                                    <ul class="ul-carusel">
                                        <li class="li-carusel" *ngFor="let v of c.valores">{{v}}</li>
                                    </ul>
                                </mat-card-content>
                            </ng-container>
                        </mat-card>
                    </div>
              </div>
            </div>
        </div>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="col-12">
            <h3 class="title">¿Qué es una póliza?</h3>
        </div>
        <div class="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4" *ngFor="let p of poliza">
            <mat-card class="card-que-es-una-poliza shadow">
                <div class="div-img">
                    <img mat-card-image [src]="p.img" [alt]="p.titulo">
                </div>
                <mat-card-title>{{p.titulo}}</mat-card-title>
                <mat-card-content>
                    <p class="descripcion" [innerHTML]="p.descripcion"></p>
                </mat-card-content>
            </mat-card>
            <hr class="d-block d-sm-block d-md-none d-lg-none d-xl-none d-xxl-none">
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <h3 class="title">Pólizas Jurídicas Coberturas</h3>
        </div>
        <div class="col-4 d-none d-sm-none d-md-block d-lg-block d-xl-block d-xxl-block" *ngFor="let c of cobertura;let i = index">
            <mat-card class="card-polizas cardPolizas" ngClass="card-{{i+1}}">
                <img [src]="c.icono" [alt]="c.titulo">
                <mat-card-title>{{c.titulo}}</mat-card-title>
                <mat-card-actions>
                    <button [routerLink]="['/','polizasJuridicas']" mat-flat-button class="shadow">{{c.btn}}</button>
                </mat-card-actions>
            </mat-card>
        </div>
        <!--
            responsivo
        -->
        <div id="carouselCoberturasQuienesSomos" class="carousel slide d-block d-sm-block d-md-none d-lg-none d-xl-none d-xxl-none" data-bs-ride="carousel">
            <div class="carousel-indicators">
              <button type="button" data-bs-target="#carouselCoberturasQuienesSomos" [attr.data-bs-slide-to]="j" [ngClass]="{'active': j == 0}" *ngFor="let c of cobertura;let j = index" aria-current="true" aria-label="Slide {{j+1}}"></button>
            </div>
            <div class="carousel-inner">
                <div class="carousel-item" 
                 [ngClass]="{'active':i==0}" 
                 data-bs-interval="20000" 
                 *ngFor="let c of cobertura;let i = index"
                 (swipeleft)="sliderCarusel('left','carouselCoberturasQuienesSomos')" 
                 (swiperight)="sliderCarusel('right','carouselCoberturasQuienesSomos')">
                    <mat-card class="card-polizas card-{{i+1}}">
                        <img [src]="c.icono" [alt]="c.titulo">
                        <mat-card-title>{{c.titulo}}</mat-card-title>
                        <mat-card-actions>
                            <button [routerLink]="['/','polizasJuridicas']" mat-flat-button class="shadow">{{c.btn}}</button>
                        </mat-card-actions>
                    </mat-card>
              </div>
            </div>
        </div>
    </div>
</div>